import { DecayAssignments, DecayProfile } from "../types/decay";

const DEFAULT_DECAY_PROFILES: DecayProfile[] = [
  {
    id: "default-fast",
    name: "fast",
    q1_days: 30,
    q1_multiplier: 1.0,
    q2_days: 60,
    q2_multiplier: 0.5,
    q3_days: 90,
    q3_multiplier: 0.25,
    limit_days: 120,
  },
  {
    id: "default-medium",
    name: "medium",
    q1_days: 30,
    q1_multiplier: 1.0,
    q2_days: 60,
    q2_multiplier: 0.5,
    q3_days: 90,
    q3_multiplier: 0.25,
    limit_days: 120,
  },
  {
    id: "default-slow",
    name: "slow",
    q1_days: 30,
    q1_multiplier: 1.0,
    q2_days: 60,
    q2_multiplier: 0.5,
    q3_days: 90,
    q3_multiplier: 0.25,
    limit_days: 120,
  },
];

const DEFAULT_DECAY_ASSIGNMENTS: DecayAssignments = {
  "artist:view": "default-fast",
  "artist:share": "default-slow",
  "artist:screen_captured": "default-medium",
  "genre:view": "default-fast",
  "genre:share": "default-slow",
  "genre:screen_captured": "default-medium",
  "venue:view": "default-fast",
  "venue:share": "default-slow",
  "venue:screen_captured": "default-medium",
  "event:view": "default-fast",
  "event:share": "default-slow",
  "event:screen_captured": "default-medium",
  "event:ticket_view": "default-medium",
  "event:ticket_purchase": "default-slow",
  "event:offer_view": "default-fast",
};

export { DEFAULT_DECAY_PROFILES, DEFAULT_DECAY_ASSIGNMENTS };
